/**
 * Mappings for Contentful content types
 */
export const CONTENT_TYPE = {
  PAGE: 'page',
  LONG_FORM_CONTENT: 'longFormContent',
  ARTICLE: 'article',
  CONSUMER_BLOG: 'consumerBlog',
  CORPORATE_BLOG: 'corporateBlog',
}

export const HASHMAP_ENTRY = { ID: '7ggz9PXbcsdctT3K08TG9i' }
